module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "stitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("The House by the Sea")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "stitle1a"
  }, [_vm._v("Previously published as The Mermaid Garden")]), _vm._v(" "), _c('p', {
    staticClass: "stitle2"
  }, [_vm._v("Santa Montefiore")]), _vm._v(" "), _c('p', {
    staticClass: "stitle3"
  }, [_vm._v("Simon & Schuster Paperbacks")]), _vm._v(" "), _c('p', {
    staticClass: "stitle4"
  }, [_vm._v("New York London Toronto Sydney New Delhi")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e160e06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 66
// module chunks = 0